/* eslint no-console:0 */

import { mountComponents } from '../utilities/mountComponent'
import ComponentRegistry from '../utilities/componentRegistry'

import zxcvbn from 'zxcvbn'
window.zxcvbn = zxcvbn

import 'playbook-ui/dist/playbook-rails.js'
import 'playbook-ui/dist/playbook-rails-charts.js'
import '../../../../playbook/app/javascript/playbook-doc.js'
import "@powerhome/playbook-icons/css/pb-icons.css"
import 'maplibre-gl/dist/maplibre-gl.css'
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'

import '../site_styles/main.scss'

import { Website } from 'website/src/app'

// Icons from playbook-icons-react for testing
import * as icons from "@powerhome/playbook-icons-react"

window.PB_ICONS = {}

function pascalToKebabCase(str) {
  return str
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/([a-zA-Z])([0-9])/g, '$1-$2')
    .replace(/([0-9])([a-zA-Z])/g, '$1-$2')
    .toLowerCase()
    // Heading icons export as H1..H6 but icon props use h1..h6 (no hyphen)
    .replace(/^h-(\d)$/, 'h$1')
}

Object.entries(icons).forEach(([key, value]) => {
  const iconName = pascalToKebabCase(key)
  window.PB_ICONS[iconName] = value
})

ComponentRegistry.registerComponents({
  Website,
})

// The import above mounts immediately, before Website is registered.
mountComponents()
